/**
 * PAGE D'ENTRÉE QR — /commencer
 * Cible du NOUVEAU code QR (domaine actuel kaizenfranchise.com).
 * Mobile-first, 2 choix clairs : réserver un cours d'essai payant OU s'inscrire.
 */
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight, Flame } from "lucide-react";

const LOGO = "/logos/kaizen_system/generated/kaizen_system_master_white_on_black.png";

export default function Commencer() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-zinc-950 via-black to-zinc-900 text-white flex flex-col items-center justify-center px-6 py-12" data-testid="commencer-page">
      <img src={LOGO} alt="KAIZEN SYSTEM" className="h-12 object-contain mb-8" data-testid="commencer-logo" />

      <div className="text-center max-w-md mb-10">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-300 text-xs mb-5">
          <Sparkles className="w-3.5 h-3.5" /> Institut Impact Élite Martial · Val-d'Or
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold leading-tight mb-3">
          Bienvenue au dojo. <span className="bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent">Par où veux-tu commencer ?</span>
        </h1>
        <p className="text-zinc-400 text-sm">Muay Thaï · Kickboxing · Jiu-Jitsu Brésilien · Jiu-jitsu Can Ryu · Petits Samouraïs</p>
      </div>

      <div className="w-full max-w-md space-y-4">
        <Link to="/cours-essai?src=qr" data-testid="commencer-essai"
          className="group block rounded-2xl border border-amber-500/40 bg-gradient-to-br from-amber-500/10 to-transparent p-6 hover:border-amber-400 transition-colors">
          <div className="flex items-center justify-between">
            <div>
              <div className="flex items-center gap-2 text-amber-300 text-xs font-semibold uppercase tracking-wide mb-1">
                <Flame className="w-4 h-4" /> Sans engagement
              </div>
              <div className="text-xl font-bold">Réserver un cours d'essai — 19,99 $</div>
              <div className="text-sm text-zinc-400 mt-1">Viens vivre l'ambiance du dojo. C'est offert.</div>
            </div>
            <ArrowRight className="w-6 h-6 text-amber-400 group-hover:translate-x-1 transition-transform flex-shrink-0" />
          </div>
        </Link>

        <Link to="/adhesion?src=qr" data-testid="commencer-inscription"
          className="group block rounded-2xl border border-zinc-700 bg-zinc-900/60 p-6 hover:border-zinc-500 transition-colors">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-xs font-semibold uppercase tracking-wide text-zinc-400 mb-1">Je suis prêt(e)</div>
              <div className="text-xl font-bold">M'inscrire maintenant</div>
              <div className="text-sm text-zinc-400 mt-1">Choisis ta discipline et ton forfait.</div>
            </div>
            <ArrowRight className="w-6 h-6 text-zinc-400 group-hover:translate-x-1 transition-transform flex-shrink-0" />
          </div>
        </Link>
      </div>

      <p className="text-[11px] text-zinc-600 mt-10 text-center max-w-xs">
        Frais d'inscription uniques de 40 $ (à vie, toutes disciplines) + taxes en sus à l'inscription. Cours d'essai : 19,99 $ + taxes · Forfait Découverte 2 semaines illimité : 120 $ + taxes.
      </p>
      <Link to="/horaire" className="text-xs text-zinc-500 hover:text-zinc-300 mt-4" data-testid="commencer-horaire">Voir l'horaire des cours →</Link>
    </div>
  );
}
